import { render, staticRenderFns } from "./ProgramManage.vue?vue&type=template&id=780ed1b0&scoped=true"
import script from "./ProgramManage.vue?vue&type=script&lang=js"
export * from "./ProgramManage.vue?vue&type=script&lang=js"
import style0 from "./ProgramManage.vue?vue&type=style&index=0&id=780ed1b0&prod&lang=scss&scoped=true"
import style1 from "./ProgramManage.vue?vue&type=style&index=1&id=780ed1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ed1b0",
  null
  
)

export default component.exports